import React from "react";
import "./orgadminenrollment.scss";
// import '../../assets/sass/main.scss';
import MimoLogo from "../../containers/layout/sidebar/mimoLogo";
import { Button, Form, OverlayTrigger, Tooltip } from "react-bootstrap";

import EnrollmentNotification from "../../components/enrollmentNotification";
import useOrgEnrollment from "./useOrgEnrollment";
import Spinner from "../../components/ui/spinner";
import InformationCircle from "../../assets/images/info-circle.svg";

const OrgAdminEnrollment = () => {
  const {
    isVerified,
    isEnrolled,
    name,
    email,
    password,
    confirmPassword,
    passwordError,
    confirmPasswordError,
    isPasswordEnable,
    isEnrollmentFailed,
    handleOrgAdminEnrollment,
    setName,
    setEmail,
    setPhoneNo,
    setAddress,
    setPassword,
    setConfirmPassword,
    setPasswordError,
    setConfirmPasswordError,
    setIsPasswordEnable,
    setAdminName,
    isLoading,
    enrollOrgApiStatus,
    isTokenVerificationFailed,
    handlePasswordChange,
    handleConfirmPasswordChange,
  } = useOrgEnrollment();

  if (isTokenVerificationFailed) {
    return (
      <div>
        <h2>
          Token verification failed. Please check your verification link or try
          again.
        </h2>
      </div>
    );
  }
  return (
    <>
      <Spinner isActive={isLoading} />
      {isEnrolled && <EnrollmentNotification title={"Success!"} message={""} />}
      {isEnrollmentFailed && (
        <EnrollmentNotification
          title={"Oops! Something went wrong"}
          message={enrollOrgApiStatus.error}
        />
      )}
      {!isEnrollmentFailed && !isEnrolled && isVerified && (
        <div className="org-admin-enroll-container">
          <MimoLogo />
          <div className="org-admin-enroll-content">
            <h1>Organization Admin Enrollment</h1>
            <hr></hr>
            <Form onSubmit={handleOrgAdminEnrollment}>
              <div className="org-admin-input">
                <Form.Label htmlFor="organizationName">
                  Organization Name
                </Form.Label>
                <Form.Control
                  type="text"
                  id="organizationName"
                  placeholder="Enter organization name"
                  aria-describedby="organizationName"
                  value={name}
                  disabled={true}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
              <div className="org-admin-input">
                <Form.Label htmlFor="organizationadminEmail">
                  Organization Admin Email
                </Form.Label>
                <Form.Control
                  type="email"
                  id="organizationadminEmail"
                  placeholder="Enter email address"
                  aria-describedby="organizationadminEmail"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={true}
                  required
                />
              </div>
              <div className="org-admin-input">
                <Form.Label htmlFor="adminName">Admin Name</Form.Label>
                <Form.Control
                  type="text"
                  id="adminName"
                  placeholder="Enter your name"
                  aria-describedby="adminName"
                  onChange={(e) => setAdminName(e.target.value)}
                  required
                />
              </div>

              <div className="org-admin-checkbox">
                <Form.Label htmlFor="enablePassword">
                  Sign-In Preference{" "}
                  {!isPasswordEnable && (
                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip id="password-disabled-tooltip">
                          {/* If password is disabled, the user will only be able to login using their Microsoft or Google account linked with the registered email address. */}
                          Use a valid Google or Microsoft email—both personal
                          and work accounts are supported.
                        </Tooltip>
                      }
                    >
                      <span
                        style={{
                          cursor: "pointer",
                          marginLeft: "5px",
                          color: "#0d6efd",
                        }}
                      >
                        <img
                          src={InformationCircle}
                          alt="Info"
                          width={18}
                          height={18}
                        />
                      </span>
                    </OverlayTrigger>
                  )}
                </Form.Label>
                <div className="checkbox">
                  <Form.Check
                    inline
                    type="radio"
                    label="Google/Microsoft"
                    name="enablePassword"
                    onChange={() => {
                      setIsPasswordEnable(false);
                      setPasswordError("");
                      setPassword("");
                      setConfirmPassword("");
                      setConfirmPasswordError("");
                    }}
                    checked={!isPasswordEnable}
                  />
                  <Form.Check
                    inline
                    type="radio"
                    label="Email & Password"
                    id="organizationadminEnablePassword"
                    aria-describedby="organizationadminEnablePassword"
                    name="enablePassword"
                    onChange={() => setIsPasswordEnable(true)}
                    checked={isPasswordEnable}
                  />
                </div>
              </div>

              {isPasswordEnable && (
                <>
                  <div className="org-admin-input">
                    <Form.Label htmlFor="password">Password</Form.Label>
                    <Form.Control
                      type="password"
                      id="organizationadminPassword"
                      placeholder="Enter password"
                      aria-describedby="organizationadminPassword"
                      value={password}
                      onChange={handlePasswordChange}
                      disabled={!isPasswordEnable}
                      required={isPasswordEnable}
                    />
                    {passwordError && (
                      <p style={{ color: "red" }}>{passwordError}</p>
                    )}
                  </div>
                  <div className="org-admin-input">
                    <Form.Label htmlFor="password">Confirm Password</Form.Label>
                    <Form.Control
                      type="password"
                      id="organizationadminConfirmPassword"
                      placeholder="Enter Confirm password"
                      aria-describedby="organizationadminConfirmPassword"
                      value={confirmPassword}
                      onChange={handleConfirmPasswordChange}
                      disabled={!isPasswordEnable}
                      required={isPasswordEnable}
                    />
                    {confirmPasswordError && (
                      <p style={{ color: "red" }}>{confirmPasswordError}</p>
                    )}
                  </div>{" "}
                </>
              )}

              <div className="org-admin-input">
                <Form.Label htmlFor="phoneNumber">Phone Number</Form.Label>
                <Form.Control
                  type="number"
                  id="phoneNumber"
                  placeholder="Enter phone number"
                  aria-describedby="phoneNumber"
                  onChange={(e) => setPhoneNo(e.target.value)}
                  required
                />
              </div>

              <div className="org-admin-input">
                <Form.Label htmlFor="address">Address</Form.Label>
                <Form.Control
                  type="text"
                  id="address"
                  placeholder="Enter Address"
                  aria-describedby="Address"
                  onChange={(e) => setAddress(e.target.value)}
                  required
                />
              </div>

              <div className="org-admin-enroll-btn">
                <Button type="submit">Enroll</Button>
              </div>
            </Form>
          </div>
        </div>
      )}
    </>
  );
};

export default OrgAdminEnrollment;
